import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Check } from 'lucide-react';
const CHECKOUT_URL = 'https://deco-emprende.impultienda.ar/checkout/falso-vitral-deco';
const included = ['Guía práctica Falso Vitral Deco', 'Bono 1 · Plantillas para practicar', 'Bono 2 · +300 plantillas listas para imprimir', 'Bono 3 · +100 ideas para vender', 'Bono 4 · Guía de emprendimiento'];
export function PurchaseSection() {
  const [timeLeft, setTimeLeft] = useState({
    minutes: 30,
    seconds: 0
  });
  const [isArgentina, setIsArgentina] = useState(false);
  useEffect(() => {
    let active = true;
    fetch('https://ipapi.co/json/').then(res => res.json()).then(data => {
      if (active) setIsArgentina(data?.country_code === 'AR');
    }).catch(() => {
      if (active) setIsArgentina(false);
    });
    return () => {
      active = false;
    };
  }, []);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          minutes,
          seconds
        } = prev;
        seconds -= 1;
        if (seconds < 0) {
          seconds = 59;
          minutes -= 1;
        }
        if (minutes < 0) {
          minutes = 0;
          seconds = 0;
        }
        return {
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const pad = (n: number) => n.toString().padStart(2, '0');
  const price = isArgentina ? '19.990' : '14.99';
  const currency = isArgentina ? 'ARS' : 'USD';
  const oldPrice = isArgentina ? '$39.990 ARS' : '$29.99 USD';
  return <section id="comprar" className="bg-deco-forest py-14 sm:py-20 px-4 sm:px-6 lg:px-8 scroll-mt-6" data-id="element-134" data-mp="1px1bdt7yuje5">
      <div className="max-w-2xl mx-auto text-center" data-id="element-135" data-mp="1uwdtk0nw72ae">
        <p className="text-[10px] sm:text-xs font-semibold uppercase tracking-[0.25em] text-deco-aqua mb-4" data-id="element-136" data-mp="1uy8dpcrcaqdf">
          Oferta por tiempo limitado
        </p>
        <h2 className="font-serif text-2xl sm:text-4xl text-deco-cream font-semibold leading-snug mb-4" data-id="element-137" data-mp="24vd2zlghf1yg">
          Accede hoy a{' '}
          <span className="italic text-deco-aqua" data-id="element-138" data-mp="1f41zjc1gapqj">Falso Vitral Deco</span>
        </h2>
        <p className="text-sm text-deco-cream/60 max-w-lg mx-auto mb-9 leading-relaxed" data-id="element-139" data-mp="1a8mp6u2njbyv">
          Recibes la guía paso a paso, las plantillas para practicar, +300
          plantillas listas para imprimir, +100 ideas para vender y la guía de
          emprendimiento.
        </p>

        <div className="flex items-center justify-center gap-3 mb-9" data-id="element-140" data-mp="1xvcnplfskoeq">
          <span className="text-[11px] sm:text-xs uppercase tracking-[0.18em] text-deco-cream/50 font-semibold" data-id="element-141" data-mp="1sy2oxf6ij0e8">
            Termina en
          </span>
          <div className="flex items-center gap-1.5 font-mono text-base sm:text-lg font-bold text-deco-forest" data-id="element-142" data-mp="27u257d3s06ug">
            <span className="bg-deco-cream rounded-lg px-3 py-1.5 min-w-[46px] text-center" data-id="element-143" data-mp="22twb7qa1a897">
              {pad(timeLeft.minutes)}
            </span>
            <span className="text-deco-cream/50" data-id="element-144" data-mp="8irc8z9w6k07">:</span>
            <span className="bg-deco-cream rounded-lg px-3 py-1.5 min-w-[46px] text-center" data-id="element-145" data-mp="8k2bqmwb15li">
              {pad(timeLeft.seconds)}
            </span>
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-deco-cream rounded-[2rem] p-7 sm:p-10 shadow-2xl text-left" data-id="element-146" data-mp="2p3cx7ilv8vr1">
          <p className="text-center text-[10px] font-semibold uppercase tracking-[0.2em] text-deco-brick bg-deco-brick/10 rounded-full px-4 py-1.5 inline-block mx-auto w-full sm:w-auto mb-8" data-id="element-147" data-mp="25g6rn4am461n">
            Bonos incluidos solo por hoy
          </p>

          <ul className="flex flex-col gap-3 mb-9" data-id="element-148" data-mp="1wg9yapda2j09">
            {included.map(item => <li key={item} className="flex items-start gap-3" data-id="element-149" data-mp="3lvgh2g28vvjx">
                <span className="w-5 h-5 rounded-full bg-deco-forest text-deco-cream flex items-center justify-center shrink-0 mt-0.5" data-id="element-150" data-mp="3qt9kj1c5ybgi">
                  <Check size={11} strokeWidth={3} data-id="element-151" data-mp="1qpyx52kqpaco" />
                </span>
                <span className="text-[13px] sm:text-sm text-deco-forest/80 leading-relaxed" data-id="element-152" data-mp="1lrnpmyhx3bxm">
                  {item}
                </span>
              </li>)}
          </ul>

          <div className="flex flex-col items-center gap-1.5 mb-8 pt-7 border-t border-deco-forest/10" data-id="element-153" data-mp="1crr2x2f38n57">
            <span className="text-sm text-deco-forest/45 line-through font-serif" data-id="element-154" data-mp="17sxqzefg9475">
              {oldPrice}
            </span>
            <div className="flex items-baseline gap-2" data-id="element-155" data-mp="130w5r30b034z">
              <span className="font-serif text-5xl sm:text-6xl font-semibold text-deco-brick leading-none" data-id="element-156" data-mp="y2kz115b28qz">
                ${price}
              </span>
              <span className="font-serif text-xl text-deco-forest/50" data-id="element-157" data-mp="u2ki99uqhlgr">
                {currency}
              </span>
            </div>
            <span className="text-[11px] text-deco-forest/45 font-medium mt-1" data-id="element-158" data-mp="k2tnd729h4g5">
              Pago único · Acceso de por vida
            </span>
          </div>

          <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="block w-full py-4 px-6 rounded-full bg-deco-brick text-white font-semibold text-sm sm:text-base uppercase tracking-wide hover:bg-deco-brick-dark transition-colors duration-200 shadow-lg text-center" data-id="element-159" data-mp="2vpndoom7hfz3">
            Quiero acceder ahora
          </a>

          <div className="flex items-center justify-center gap-2 mt-4 text-[11px] text-deco-forest/50 font-medium" data-id="element-160" data-mp="2d0yty5zglgow">
            <ShieldCheck size={14} data-id="element-161" data-mp="2hz0dst4plk1f" />
            <span data-id="element-162" data-mp="2m0m01534vaoa">Acceso inmediato · Producto digital · Pago seguro</span>
          </div>
        </motion.div>
      </div>
    </section>;
}